import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
    user: {},
    error: '', // for error message
    loading: false,
    isUserLogout: false,
    errorMsg: false, // for error,
    userConfig: [],
    departmentOptions : []
};

const loginSlice = createSlice({
    name: 'Login',
    initialState,
    reducers: {
        apiError(state, action) {
            state.error = action.payload.data;
            state.loading = false;
            state.isUserLogout = true;
            state.errorMsg = true;
        },
        loginSuccess(state, action) {
            state.user = action.payload;
            state.loading = false;
            state.errorMsg = false;
            state.isUserLogout = false;
        },
        logoutUserSuccess(state, action) {
            state.user = {};
            state.isUserLogout = true;
        },
        resetLoginFlaag(state) {
            state.error = '';
            state.loading = false;
            state.errorMsg = false;
            state.isUserLogout = false;
        },
        handleUserConfig(state, action) {
            state.userConfig = action.payload;
        },
        setloginloader(state, action) {
			state.loading = action.payload.loading;
		},
          addDepartmentOptions(state:any,action:any){
            state.departmentOptions = action.payload;
        }

    }
});

export const { apiError, loginSuccess, logoutUserSuccess, resetLoginFlaag, handleUserConfig, setloginloader,addDepartmentOptions } = loginSlice.actions;

export default loginSlice.reducer;
